import { useState } from 'react';

import ContactsMap from '../Courses/CommonComponents/ContactsMap';
import DirectionPreview from '../common/DirectionPreview';
import { SECTIONS } from '../../../constants/courses';
import kidsDescriptionBG from '../../../assets/directions/kidsDescriptionBG.png';
import { CursesSections } from '../../../types/common';

import { EventWrapper } from './styles';

const Kids = () => {
   const [isModalOpened, setIsModalOpened] = useState(false);

   const handleDirectionAction = () => {
      setIsModalOpened(!isModalOpened);
   }

   return (
      <EventWrapper>
         <DirectionPreview
            bgImage={kidsDescriptionBG}
            sectionName={SECTIONS.kids as CursesSections}
            customTag={'Интервью'}
            handleDirectionAction={handleDirectionAction}
            isButtonDisabled={true}
         />
         <ContactsMap handleButtonClick={handleDirectionAction} />
      </EventWrapper>
   );
};

export default Kids;